// antd components
import { Tooltip } from "antd";

//Props Validations
import PropTypes from "prop-types";

// mui icons
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";

//redux
import { useSelector } from "react-redux";

const MatchNetMissingFiltersTooltip = ({ missingFilters = {}, product = "" }) => {
    const dataMappingStoreData = useSelector((state) => state.dataMappingStore.displayLabelTranslation);
    const missingFiltersData = missingFilters[product].filters;

    return (
        <Tooltip
            placement="bottomRight"
            color="white"
            overlayClassName="missing-filters-tooltip"
            overlayInnerStyle={{ padding: "0px 0px 1px 0px" }}
            align={{ offset: [70, 16] }}
            title={
                <div style={{ color: "#000000" }}>
                    <p style={{ backgroundColor: "#F5F5FF", padding: "10px 20px", fontSize: "1rem", fontWeight: "500" }}>Missing filters</p>
                    {Object.keys(missingFiltersData).map((datum, i) => {
                        const displayLabel = dataMappingStoreData[datum];
                        return (
                            <div
                                style={{ padding: "0px 30px" }}
                                key={i}
                            >
                                <p>
                                    <span className="my-0 text-bold-6">{`${displayLabel}: `}</span>
                                    <span style={{ fontWeight: "400", color: "#4d4d4d" }}>{missingFiltersData[datum].map((eachFilter) => eachFilter.label).join(", ")}</span>
                                </p>
                            </div>
                        );
                    })}
                </div>
            }
        >
            <DoNotDisturbOnIcon
                sx={{ fontSize: "16px" }}
                color="error"
            />
        </Tooltip>
    );
};

// Typechecking props for the missing filters tooltip
MatchNetMissingFiltersTooltip.propTypes = {
    missingFilters: PropTypes.object,
    product: PropTypes.string,
};

export default MatchNetMissingFiltersTooltip;
